import React from 'react';
import { FormControlLabel, FormLabel } from '@mui/material';
import { AdminAccessFieldsProps } from '../types';
import { AdminAccessOptionsContainer, AdminAccessWrapper } from '../styled';
import StyledCheckbox from '../../common/styled/Checkbox';

const AdminAccessFields: React.FC<AdminAccessFieldsProps> = ({
  adminAccess,
  onChange
}) => {
  const handleToggle =
    (key: keyof AdminAccessFieldsProps['adminAccess']) => () => {
      onChange(key, !adminAccess[key]);
    };

  return (
    <AdminAccessWrapper>
      <FormLabel component='legend'>Admin Access</FormLabel>
      <AdminAccessOptionsContainer>
        <FormControlLabel
          control={< StyledCheckbox checked disabled />}
          label='Ether'
        />
        <FormControlLabel
          control={
            <StyledCheckbox
              checked={adminAccess.easypay}
              onChange={handleToggle('easypay')}
            />
          }
          label='Easypay'
        />
        <FormControlLabel
          control={
            <StyledCheckbox
              checked={adminAccess.busTracking}
              onChange={handleToggle('busTracking')}
            />
          }
          label='Bus Tracking'
        />
      </AdminAccessOptionsContainer>
    </AdminAccessWrapper>
  );
};

export default AdminAccessFields;
